<template>
  <v-card>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="page.items"
        disable-sort
        hide-default-footer
        disable-pagination
        disable-filtering
        :loading="page.loading"
        class="elevation-1"
        ><template v-slot:item.actions="{ item }">
          <a target="_blank">
            <v-btn
              :to="`/finance/mapping/edit/${item.id}`"
              class="mx-2"
              elevation="0"
              fab
              small
            >
              <v-icon color="primary">
                {{ icons.mdiPencil }}
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              elevation="0"
              fab
              small
              @click.native="openModal(item.id)"
            >
              <v-icon color="secondary">
                {{ icons.mdiTrashCan }}
              </v-icon>
            </v-btn>
          </a>
        </template>
      </v-data-table>
    </v-card-text>
    <v-dialog v-model="dialogModel.dialog" width="70vw">
      <del-confirmation
        :dialogOpen="dialogModel.dialog"
        :id="dialogModel.id"
        @openDialog="dialogModel.dialog = !dialogModel.dialog"
      ></del-confirmation>
    </v-dialog>
  </v-card>
</template>

<script>
import { mdiPencil, mdiTrashCan } from "@mdi/js";
import { computed, reactive, watch } from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";

import DelConfirmation from "@/components/finance/mapping/modals/DelConfirmation";

export default {
  name: "FinanceMappingTable",
  components: {
    DelConfirmation,
  },
  setup(props, { emit }) {
    const { store } = useProxy();
    const { axiosGet } = useAxios();

    const page = reactive({
      loading: false,
      items: [],
    });
    const dialogModel = reactive({
      dialog: false,
      id: -1,
    });

    // =>  METHODS
    const openModal = (id) => {
      dialogModel.dialog = !dialogModel.dialog;
      dialogModel.id = id;
    };

    const getData = async () => {
      if (applyFilters.value && !page.loading && entity.value && source.value) {
        page.loading = true;
        const { data } = await axiosGet("/finance/mapping/list", {
          entity: entity.value,
          source: source.value,
          search: search.value,
          replace: replace.value,
        });

        page.items = data;

        page.loading = false;

        // Force clicking on button again to re-run that request :
        // (we don't call this dispatch earlier to be sure, as state is async, that all listening components could run their requests)
        store.dispatch("common/updateApplyFilters", false);
      }
    };

    // =>  COMPUTED
    const applyFilters = computed(
      () => store.getters["common/getApplyFilters"]
    );
    const entity = computed(() => store.getters["finance/getMappingEntity"]);
    const source = computed(() => store.getters["finance/getMappingSource"]);
    const search = computed(() => store.getters["finance/getMappingSearch"]);
    const replace = computed(() => store.getters["finance/getMappingReplace"]);

    // =>  WATCH
    watch(applyFilters, () => {
      getData();
    });

    // =>  HOOKS

    // =>  DATA
    return {
      headers: [
        { text: "Source", value: "source" },
        { text: "Valeur CSV", value: "search" },
        { text: "Valeur RMR", value: "replace" },
        { value: "actions" },
      ],
      icons: {
        mdiPencil,
        mdiTrashCan,
      },
      page,
      dialogModel,
      openModal,
    };
  },
};
</script>

<style></style>
